<!-- eslint-disable max-len -->
<template>
  <div class="container">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">
        <img id="logo-orisha" class="d-block"
             src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>

        <div class="card card-orisha">
          <div class="card-header">
            <h1 class="text-center my-1 col-10 mx-auto title-balanced" v-if="currentView === 'login'">
              Bienvenue sur le portail clients Orisha Retail Shops,
              merci de vous identifier pour continuer.
            </h1>
            <h1 class="text-center my-1 col-10 mx-auto title-balanced" v-else-if="currentView === 'recovery'">
              Récupération de mot de passe
            </h1>
            <h1 class="text-center my-1 col-10 mx-auto title-balanced" v-else-if="currentView === 'register'">
              Création de compte
            </h1>
          </div>

          <div class="card-body">
            <p class="text-center dev-text-spacing" v-if="currentView === 'recovery'">
              Merci d'indiquer l'adresse email renseignée lors de la commande pour recevoir la
              procédure de récupération de mot de passe.
            </p>
            <p class="text-center dev-text-spacing" v-else-if="currentView === 'register'">
              Merci d'indiquer l'adresse email renseignée lors de la commande pour recevoir la
              procédure de création de compte.
            </p>

            <LoginForm v-if="currentView === 'login'"/>
            <EmailForm v-else-if="currentView === 'recovery'" type="recovery"/>
            <EmailForm v-else-if="currentView === 'register'" type="register"/>
          </div>

          <div class="row justify-content-center my-1 mx-auto col-11"
               v-if="currentView === 'login'">
            <div class="col-12 col-sm-6 mb-3">
              <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                      @click="showRecovery" style="margin-bottom: 5px">
                Mot de passe oublié ?
              </button>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <button type="button"
                        class="btn btn-outline-light btn-sm btn-block bg-grey"
                        @click="showRegister">
                  Créer mon compte
              </button>
            </div>
          </div>

          <div class="row justify-content-center my-4 mx-auto col-11"
               v-if="currentView !== 'login'">
            <div class="col-12">
              <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                      @click="showLogin">
                ← Retour à la connexion
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LoginForm from '../components/form/LoginForm.vue';
import EmailForm from '../components/form/EmailForm.vue';

export default {
  name: 'Login',
  data() {
    let initialView = 'login';
    if (this.$route.path === '/create') initialView = 'register';
    else if (this.$route.path === '/edit') initialView = 'recovery';
    return {
      currentView: initialView, // 'login', 'recovery', 'register'
      // Module source
      source: this.$route.query.source,
      // Chemin de destination
      path: this.$route.query.path,
      url: this.$route.query.url,
      hash: this.$route.hash || '',
    };
  },
  methods: {
    isOAuthFlow() {
      return this.$route.query.oauth === '1';
    },
    navigationQuery() {
      return {
        ...this.$route.query,
      };
    },
    checkSource() {
      if (!this.source && !this.url) {
        this.source = 'Portail';
      }
    },
    showLogin() {
      if (this.isOAuthFlow()) {
        this.$router.push({
          path: '/oauth',
          query: this.navigationQuery(),
        });
        return;
      }
      this.$router.push('/');
    },
    showRecovery() {
      this.$router.push({
        path: '/edit',
        query: this.navigationQuery(),
      });
    },
    showRegister() {
      this.$router.push({
        path: '/create',
        query: this.navigationQuery(),
      });
    },
  },
  watch: {
    $route(to) {
      if (to.path === '/create') this.currentView = 'register';
      else if (to.path === '/edit') this.currentView = 'recovery';
      else if (to.path === '/') this.currentView = 'login';
    },
  },
  created() {
    this.checkSource();
  },
  components: {
    LoginForm,
    EmailForm,
  },
};
</script>

<style scoped>
.title-balanced {
  text-wrap: balance;
}
</style>
